import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import { resetUpdateDsrOutcome, setDsrPages, updateDsr } from '../actions/dsr-actions'
import '../styles/dsr-display.scss'
import { AiFillCheckCircle } from 'react-icons/ai'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import PageLoader from '../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function DsrPublishModal({ dsrId, dsrPages, handleCloseModal,
  handleChangeUserActionRequired,
  updateDsrOutcome,
  // Actions
  updateDsr,
  resetUpdateDsrOutcome,
  setDsrPages
}) {



  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {

    if (updateDsrOutcome) {
      const { updateDsrStatus, sourceEvent } = updateDsrOutcome || {};

      if (updateDsrStatus && sourceEvent === "publish-dsr") {
        resetUpdateDsrOutcome()
        redirectToNewPage(`/dsr/${dsrId}`)
      } else if (updateDsrStatus && sourceEvent === "re-publish-dsr") {
        resetUpdateDsrOutcome()
        redirectToNewPage(`/dsr/${dsrId}`)
      }
    }

  }, [updateDsrOutcome, dsrId, resetUpdateDsrOutcome, handleChangeUserActionRequired]);

  const handleClickPublishButton = () => {
    setShowLoader(true);
    setDsrPages(dsrPages)
    updateDsr({
      dsrId,
      firstPublish: true, // Used to help guide backend to create instances in tables upon publishing a DSR
      sourceEvent: "publish-dsr",
      status: 'active',
      dsrPages
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <Box>
              <PageLoader />
            </Box>
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            Start sharing this Room with your audiences?
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickPublishButton()} label='Yes, publish' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={AiFillCheckCircle} color='brand.500' boxSize="1.6em" />
        <Box color='white'>You are about to publish the room</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrOutcome: state.updateDsrOutcome.results.data
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome,
      setDsrPages
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrPublishModal));
